<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head1">CONTENTS</p>
<p class="toc"><a href="#/Acknowledgements">Acknowledgements</a></p>
<p class="toc2"><a href="#/Introduction">Introduction. Welcome to the Machine</a></p>
<p class="toc1"><a href="#/Chapter1#C1">1. The Mahone Machine: How a Confederate General Became the Leader of a Progressive Interracial Political Machine</a></p>
<p class="toc"><span href="#/Chapter2#C2" title="Link target outside of Sample">2. The Martin Machine: Railroad Magnate Seizes Control of a Party and a Commonwealth</span></p>
<p class="toc"><span href="#/Chapter3#C3" title="Link target outside of Sample">3. Out of the Mud: Senator Byrd Takes the Road Less Traveled to the Executive Mansion</span></p>
<p class="toc"><span href="#/Chapter4#C4" title="Link target outside of Sample">4. The Rise of Harry Byrd: How a Blueblood Scion of a First Family Becomes a Political Boss in the Old Dominion</span></p>
<p class="toc"><span href="#/Chapter5#C5" title="Link target outside of Sample">5. Pay as You Go: Harry Byrd in the Executive Mansion</span></p>
<p class="toc"><span href="#/Chapter6#C6" title="Link target outside of Sample">6. Byrd for President: Virginia’s Favorite Son, the Last New Dealer</span></p>
<p class="toc"><span href="#/Chapter7#C7" title="Link target outside of Sample">7. Union Busting: Byrd Machine Senses Opportunity in the Right to Work</span></p>
<p class="toc"><span href="#/Chapter8#C8" title="Link target outside of Sample">8. The Young Turks: Fresh from the War, the Greatest Generation Takes on the Machine</span></p>
<p class="toc"><span href="#/Chapter9#C9" title="Link target outside of Sample">9. Massive Resistance: The Machine Combats Segregation with Systemic Racism</span></p>
<p class="toc"><span href="#/Chapter10#C10" title="Link target outside of Sample">10. Beginning of the End: The 1965 Election Turned Out to Be a Swan Song for the Organization</span></p>
<p class="toc1"><span href="#/Epilogue" title="Link target outside of Sample">Epilogue. The Machine Falls Apart</span></p>
<p class="toc2"><span href="#/Notes" title="Link target outside of Sample">Notes</span></p>
<p class="toc2"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?4693d2d4